import {
  Svg401,
  Svg403,
  Svg404,
  Svg500,
  Svg502,
  Svg503,
  SvgError,
} from '@itwin/itwinui-illustrations-react';
import { NonIdealState } from '@itwin/itwinui-react';
import React from 'react';
import { useThemeContext } from '../../context/themeContext';
import { themedText } from '../../styles/SharedStyles';

type ErrorPageWrapperProps = {
  errorType?: string;
  description?: string;
};

export const ErrorPageWrapper = ({
  errorType,
  description,
}: ErrorPageWrapperProps): JSX.Element => {
  const theme = useThemeContext();

  function errorSvg() {
    if (errorType === '401') {
      return <Svg401 />;
    }
    if (errorType === '403') {
      return <Svg403 />;
    }
    if (errorType === '404') {
      return <Svg404 />;
    }
    if (errorType === '500') {
      return <Svg500 />;
    }
    if (errorType === '502') {
      return <Svg502 />;
    }
    if (errorType === '503') {
      return <Svg503 />;
    }
    return <SvgError />;
  }

  function errorHeading() {
    if (errorType === '401') {
      return 'Unauthorized';
    }
    if (errorType === '403') {
      return 'Forbidden';
    }
    if (errorType === '404') {
      return 'Not Found';
    }
    if (errorType === '500') {
      return 'Internal Server Error';
    }
    if (errorType === '502') {
      return 'Bad Gateway';
    }
    if (errorType === '503') {
      return 'Service Unavailable';
    }
    return 'Error';
  }

  return (
    <NonIdealState
      svg={errorSvg()}
      heading={errorHeading()}
      description={description}
      style={themedText(theme)}
    />
  );
};
